<template>
  <v-container fluid>
    <div class="d-flex mb-4">
      <h1 class="text-h4">
        Single Sign-on Domains
        <v-btn right
               icon
               title="Reload templates"
               :disabled="loading"
               @click.prevent="fetchData">
          <v-icon v-if="loading">
            fal fa-spin fa-spinner
          </v-icon>
          <v-icon v-else>
            fal fa-sync
          </v-icon>
        </v-btn>
      </h1>
    </div>
    <p>
      Users will be required to use your company's single sign-on system if their email address ends in one of these domains.
    </p>
    <v-card class="mb-4">
      <v-data-table :headers="headers"
                    :items="domains"
                    :items-per-page="-1"
                    :loading="loading">
        <template v-slot:item.name="props">
          <v-edit-dialog :return-value.sync="props.item.name"
                         @save="save(props.item)"
                         @cancel="cancel"
                         @open="open"
                         @close="close">
            {{ props.item.name }}
            <template v-slot:input>
              <v-text-field v-model="props.item.name"
                            label="Edit"
                            single-line
                            :rules="[rules.required]"
                            :error-messages="form.errors.get('name')">
              </v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.actions="{item: domain}">
          <v-btn icon
                 @click.prevent="deleteDomain(domain.id)">
            <v-icon>
              fal fa-trash
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <create-team-domain @updated="fetchData">
    </create-team-domain>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';
import teamDomainService from '../../services/teamDomainService';
import CreateTeamDomain from './CreateTeamDomain';
import DOMPurify from 'dompurify';

export default {
  components: {CreateTeamDomain},
  mixins: [
    formValidation,
  ],
  data() {
    return {
      domains: [],
      form: new Form({
        name: '',
      }),
      headers: [
        {
          text: 'Domain Name',
          value: 'name',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      loading: false,
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    initForm() {
      this.form.name = '';
      this.form.clear();
    },
    save(domain) {
      //console.log('save', domain.name);
      this.form.name = domain.name;
      this.form.put(`/api/team-domains/${domain.id}`)
        .then(() => {
          this.$toast.success(`Domain ${DOMPurify.sanitize(domain.name)} updated.`);
        })
        .catch(err => {
          this.$toast.error(DOMPurify.sanitize(err.response.data.errors.name[0]))
        })
        .finally(() => {
          this.initForm();
          this.fetchData();
        })
    },
    cancel() {
      //console.log('cancel');
      this.initForm();
    },
    open() {
      //console.log('open');
      this.initForm();
    },
    close() {
      //console.log('close');
    },
    fetchData() {
      this.loading = true;
      teamDomainService.getDomains()
        .then(data => {
          this.domains = data;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteDomain(domainID) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      teamDomainService.delete(domainID)
        .then(() => {
          this.fetchData();
        })
    }
  }
}
</script>
